import isObject from 'lodash/isObject';
import merge from 'lodash/merge';
import AppDBStorage from '@Services/AppDBStorage';

class SearchStorage extends AppDBStorage {
  constructor() {
    super('searchId_');
  }

  getDefaultValue() {
    return {};
  }

  extendItem(key, src) {
    return this._change(key, (item) => {
      if (item && isObject(item)) {
        item = merge(item, src);
      }
      return item;
    });
  }
}

export const searchStorage = new SearchStorage();
